import { useQuery } from '@tanstack/react-query';

import { productDetailQuery } from './productDetailQuery';

export const useProductDetail = (slug: string) => useQuery(productDetailQuery(slug));
